module.exports = __webpack_public_path__ + "img/SketchPng737c8f75554fc2f7d993d38949fcb67aa93abb81d39f025a6ef4f6c7ff25cdee.9e867580.png";